export const EMOJI_CLASS = "emoji";
export const MENTION_CLASS = "mention";
const QL_MENTION_DENOTATION_CLASS = "ql-mention-denotation-char";

const GH_BLOT_MAIN_CLASSES = [EMOJI_CLASS, MENTION_CLASS];
const GH_BLOT_EXTRA_CLASSES = [QL_MENTION_DENOTATION_CLASS];

export const GH_BLOT_CLASSES = [...GH_BLOT_MAIN_CLASSES, ...GH_BLOT_EXTRA_CLASSES];
